// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBft71YGZ1vPcbxfwDwmaIOJkX9Mr0hApI",
  authDomain: "fisibility-lite.firebaseapp.com",
  databaseURL: "https://fisibility-lite-default-rtdb.firebaseio.com",
  projectId: "fisibility-lite",
  storageBucket: "fisibility-lite.appspot.com",
  messagingSenderId: "939075535503",
  appId: "1:939075535503:web:b0ab819740cee9aa5166fa",
  measurementId: "G-WJPRT9FPVZ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const auth = getAuth(app);
